function TealiumEvent() {
    this.data = {
        event: {
            ScreenName: '',
            Label: '',
            Value: '',
            Name: '',
        },
        trackingType: '',
    };
    this.type = '';
}

function TealiumEventBuilder() {
    this._tealiumEvent = new TealiumEvent();
    this.withEventType = function (eventType) {
        this._tealiumEvent.type = eventType;
        return this;
    };

    this.withEventName = function (eventName) {
        this._tealiumEvent.data.event.Name = eventName;
        return this;
    };

    this.withScreenName = function (screenName) {
        this._tealiumEvent.data.event.ScreenName = screenName;
        return this;
    };

    this.withLabel = function (label) {
        this._tealiumEvent.data.event.Label = label;
        return this;
    };

    this.withValue = function (value) {
        this._tealiumEvent.data.event.Value = value;
        return this;
    };

    this.withTrackingType = function (value) {
        this._tealiumEvent.data.trackingType = value;
        return this;
    };

    this.build = function () {
        return this._tealiumEvent;
    };
}

module.exports = TealiumEventBuilder;



// WEBPACK FOOTER //
// ./src/analytics/tealium/builders/tealium-event-builder.js